define(function (require) {
    'use strict';

    var Marionette  = require('marionette');
    var I18n        = require('i18n!nls/main');

    // Общий шаблон
    var TemplateMain = require('text!tmpls/parts/alerts/main.tpl').default;

    // Шаблон одного алерта
    var ItemTpl      = require('text!tmpls/parts/alerts/alerts_item.tpl').default;

    // Представление одного алерта
    var AlertItem = Marionette.ItemView.extend({
        model       : AlertsModel ,
        template    : ItemTpl 
    });

    // Модель алертов
    var AlertsModel  = require('models/alerts');

    // Коллекция алертов
    var AlertsCollection = Backbone.Collection.extend({
        model : AlertsModel ,
        url   : '/server/?action=getListAlerts'
    });

    return Marionette.CompositeView.extend({
        template  : TemplateMain , 
        childView : AlertItem,
        childViewContainer : '#b-alerts-list-alerts',

        initialize : function(){
            this.collection = new AlertsCollection();
            this.listenTo(this.collection, 'fetch', this.render);
            this.collection.fetch();
        } ,

        ui : {
            'deleteAlert'         : '.js-delete-alert' ,
            'clearAll'            : '.js-alerts-clear-all' ,
            'filterAllProjects'   : '.js-alerts-all-projects' ,
            'filterSingleProject' : '.js-alerts-single-project' ,
            'toggleHideShow'      : '.js-alerts-hide-show'

        } , 

        events : {
            'click @ui.deleteAlert'         : 'deleteAlert' ,
            'click @ui.clearAll'            : 'clearAll' , 
            'click @ui.filterAllProjects'   : 'filterAllProjects' ,
            'click @ui.filterSingleProject' : 'filterSingleProject' ,
            'click @ui.toggleHideShow'      : 'toggleHideShow'
        } ,

        deleteAlert : function(e){
            var id = $(e.currentTarget).attr('data-id');
            var model = this.collection.get(2);
            // console.log(model);
            this.collection.remove(model);

            $(e.currentTarget).closest('.b-notice__block').addClass('animated slideOutRight');
            setTimeout(function(){
                $(e.currentTarget).closest('.b-notice__block').addClass('hide')
            }, 1000);
        } ,

        clearAll : function(){
            var that = this;
            $('#b-alerts-list-alerts').addClass('animated fadeOutRight');
            
            setTimeout(function(){
                that.collection.reset();
            }, 1000);
        } ,

        filterAllProjects : function(){
            $('.js-alerts-all-projects').addClass('active');
            $('.js-alerts-single-project').removeClass('active');

            $('.b-notice__block, .b-caller__project_name').removeClass('hide');
        } ,

        filterSingleProject : function(){
            $('.js-alerts-single-project').addClass('active');
            $('.js-alerts-all-projects').removeClass('active');

            // test main project id
            var main_project = 1;

            $('.b-caller__project_name').addClass('hide');

            $('.b-notice__block').each(function(i, e) {
                if(!$(e).hasClass('js-alert-site-' + main_project)) {
                    $(e).addClass('hide');
                }
            });
        } ,

        toggleHideShow : function(e){
            var id = $(e.currentTarget).attr('data-id');
            $(e.currentTarget).children('span').toggle();
            $('.js-alert-site-' + id).toggle();
        }

    });        
 });
